import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import { loadMaritalStatus, loadMaritalStatusFailure, loadMaritalStatusSuccess } from './marital-status.actions';

@Injectable()
export class MaritalStatusEffects {
  private actions$ = inject(Actions);
  private referenceService = inject(ReferenceService);

  constructor() {}

  loadMaritalStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadMaritalStatus),
      switchMap(() =>
        this.referenceService.referenceLookupGetMaritalStatusGet().pipe(
          map((response) => loadMaritalStatusSuccess({ maritalStatus: response.result || [] })),
          catchError((error) => of(loadMaritalStatusFailure({ error }))),
        ),
      ),
    ),
  );
}
